import _ from 'lodash'
import Backbone from 'backbone'
import $ from 'jquery'
import Actor from './actor'
import highlight from 'scoreboard/components/highlight'
import i18n from 'scoreboard/components/i18n'
import FormHelper from 'scoreboard/components/form-helper'
const { readFromDom } = FormHelper
import FilterElements from 'scoreboard/components/filter-elements'
const { filterElementAndChildren } = FilterElements

/**
 * Saves a record
 */
class SaveRecordActor extends Actor {

	isDisplayingDoneCheckmark() { return true }

	readFromDom() {
		// #53350 if we're not saving a record using the save button on a record list widget
		// then we need to filter out all record list widgets from being read from the dom
		// because the output of readFromDom will include values that are editable, but
		// haven't necessarily been edited.
		const nonRecordListElements = filterElementAndChildren(
			this.formView, '.record-list-widget')
		return readFromDom(nonRecordListElements)
	}

	act() {
		const record = this.getData()
		const recordsRequest = {
			fieldIds: _.map(this._getRecordFields(), 'id'),
			records: [record],
			fromForm: true
		}

		let params = this.options.formDirector.requestParams()
		let url = `api/datasets/${this.model.dataset.id}/records${params}`
		let xhr = $.post({
			url,
			data: JSON.stringify(recordsRequest),
			success: (records) => {
				// If the primary key was provided to the server, the record
				// we get back will be no different than what we originally
				// passed up. However, if the primary wasn't provided then the
				// server generates one, and we need that primary key value to
				// ensure that if we modify more fields and save again, we are
				// modifying the same record
				let savedRecord = _.isNil(records[0]) ?
					null : records[0]

				// #54408 the raw record won't change so we don't need to send
				// it back and forth to the server. instead we can just add it
				// back to the response here
				const rawRecord = this.options.formDirector?.record?.rawRecord
				if (rawRecord) savedRecord.rawRecord = rawRecord

				this.options.formDirector.setRecord(savedRecord)
				this.options.formDirector.setPreviousRecord(savedRecord)

				// #35136 get the form out of the submitting state
				this.formView.start()
				this.trigger('done', recordsRequest.records)

				// if there is still a "go to page" actor after this, then we
				// want to leave the busy button alone while the form director
				// continues to work
				if (!this.options.hasGoToPage) this.options.busyButton?.enable()
			},
			error: xhr => {
				if (xhr?.responseJSON?.messageCode === 'forms.widgets.button.tooltip.noNewAllowed') {
					const { label, id } = this.model.dataset.attributes
					this.formView.error(recordInsertionNotAllowedMessage(label, id))
				} else {
					this.formView.error(xhr)
				}

				// #40951 display the error but keep the form dirty
				// since the record didn't save
				this.formView.change()
			}
		})
		return xhr
	}
}

const recordInsertionNotAllowedMessage = (label, id) => {
	const arg1 = highlight(i18n.get('datasets.records.newAllowed'))
	const arg2 = `<a class="text-link is-inlined sp-navigate" href=/datasets/${id}>` + _.escape(label) + `</a>`
	return i18n.get('forms.widgets.button.tooltip.noNewAllowed', arg1, arg2)
}

_.extend(SaveRecordActor.prototype, Backbone.Events)
_.extend(SaveRecordActor, { recordInsertionNotAllowedMessage })
export default SaveRecordActor
export { recordInsertionNotAllowedMessage }

SaveRecordActor.__filename__ = 'forms/actions/save-record-actor.js'
